export const EVENT_OPEN_REFER_BALLS_DRAWER = "OPEN_BALL_RECORDS";
export const EVENT_CLOSE_REFER_BALLS_DRAWER = "CLOSE_BALL_RECORDS";
